import { SHADE_CLEAR_ICON_SIZE, SHADE_CLEAR_ICON_SMALL_SIZE } from "../constants";
import { ShadeSize } from "../types";
export var getShadeClearIconSize = function getShadeClearIconSize(size) {
  return size === ShadeSize.Medium ? SHADE_CLEAR_ICON_SIZE : SHADE_CLEAR_ICON_SMALL_SIZE;
};
//# sourceMappingURL=getShadeClearIconSize.js.map